'use strict';

const $loadMoreBtn = $('#loadMoreBtn');
const $blogEntriesContainer = $('#blogEntriesContainer');
const $errorMessage = $('#error-message');
const $categoriesSelect = $('#categories-select');
const $bottomSheetCategories = $('#categoriesBottomSheet .category-item');

function handleCategoryFilterClick(event) {
    const $clickedItem = $(event.currentTarget);
    $bottomSheetCategories.removeClass('selected');
    $clickedItem.addClass('selected');
}

function handleLoadMoreEntriesClick() {
    const nextPage = parseInt($loadMoreBtn.data('page'));
    const category = $loadMoreBtn.data('category');
    $loadMoreBtn.attr("disabled", true);

    $.ajax({
        url: $loadMoreBtn.data('url'),
        method: 'POST',
        data: { 
            page: nextPage,
            category: category
        },
        success: function(response) {
            $loadMoreBtn.attr("disabled", false);
            if (response.htmlEntryCards) {
                $blogEntriesContainer.append(response.htmlEntryCards);
                var nextPageOnNextClick = nextPage + 1;
                $loadMoreBtn.data('page', nextPageOnNextClick);
                
                if (nextPageOnNextClick >= response.pagination.pageCount) {
                    $loadMoreBtn.hide();
                }
            } else {
                showErrorMessage($errorMessage.data('entriesError'));
            }
        },
        error: function() {
            $loadMoreBtn.attr("disabled", false);
            showErrorMessage($errorMessage.data('connectionError'));
        }
    });
}

function showErrorMessage(message) {
    $('#error-message').text(message).show();
    setTimeout(function() {
        $errorMessage.hide();
    }, 5000);
}

function handleCategoryChange() {
    const $select = $(this);
    const selectedCategory = $select.val();
    const showUrl = $select.data('show-url');
    const $selectedOption = $select.find('option:selected');
    const url = $selectedOption.data('url');

    if (selectedCategory && url) {
        window.location.href = url;
    } else {
        window.location.href = showUrl;
    }
}

const initBlog = function() {
    $loadMoreBtn.on('click', handleLoadMoreEntriesClick);
    $categoriesSelect.on('change', handleCategoryChange);
    $bottomSheetCategories.on('click', handleCategoryFilterClick);
};

module.exports = {
    initBlog: initBlog
};